import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "home",
  class: "hero-section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar_component = _resolveComponent("navbar-component")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_parallax = _resolveComponent("v-parallax")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_v_parallax, { height: "800" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          src: _ctx.heroImage,
          height: "800",
          cover: "",
          position: "top"
        }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"position":"absolute","bottom":"0","width":"100%","height":"100%","background":"linear-gradient(\n          to bottom,\n          rgba(0,0,0,0.10) 20%,\n          rgba(0,0,0,0.90) 100%\n        )"} }, null, -1)),
            _createVNode(_component_navbar_component, { onIsNavbarIconActive: _ctx.handleNavbarIconActive }, null, 8, ["onIsNavbarIconActive"]),
            _createVNode(_component_v_row, { class: "fill-height justify-center align-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-h2 font-weight-bold white--text mb-4" }, " CAPTURING MOMENTS THAT LAST FOREVER ", -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-h5 white--text mb-6" }, " Professional Photography for Every Occasion ", -1)),
                    _createVNode(_component_v_btn, {
                      "x-large": "",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _cache[1] || (_cache[1] = _createTextVNode(" View Portfolio ", -1)),
                        _createVNode(_component_v_icon, { right: "" }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-arrow-down", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _: 1
    })
  ]))
}